import {Injectable} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {State} from '../state';
import {StateContext} from '../state.context';
import {EmailVerificationService} from "../../../shared/services/email-verification/email-verification.service";

/**
 * Starts the page-specific ForgeRock profile-edit journey.
 */
@Injectable({
  providedIn: "root"
})
export class InitState implements State {
  name = 'InitState';

  constructor(
    private stateContext: StateContext,
    private emailVerificationService: EmailVerificationService
  ) {}

  /**
   * Initialize ForgeRock Email verification journey using the profile selected at the edit entry point.
   */
  start(): Observable<any> {
    console.debug(`🔑 SERVICE:init$`);
    return this.emailVerificationService.initFRConfig(this.stateContext.getJourney().updateProfile).pipe(
      switchMap((state => this.stateContext.changeState(state))),
      catchError( err => {
        console.warn(`🔑 SERVICE:init$`, err?.message ?? err);
        return throwError(() => err);
      })
    );
  }
}
